// App version, baked in at build time by Vite (see vite.config.ts).
//
// Format: MAJOR.MINOR.REVISION.BUILD  — e.g. "2.1.260701.2"
//   MAJOR.MINOR  release line (2.1)
//   REVISION     build's UTC calendar day, YYMMDD (260701 = 2026-07-01)
//   BUILD        Nth deploy of that day (0 for un-stamped local builds)
export const APP_VERSION: string = __APP_VERSION__;

export interface AppVersionParts {
  major: number;
  minor: number;
  /** Raw YYMMDD revision string, e.g. "260701". */
  revision: string;
  build: number;
}

/** Split APP_VERSION into its parts for display or comparison. */
export function parseVersion(v: string = APP_VERSION): AppVersionParts {
  const [major, minor, revision, build] = v.split('.');
  return {
    major: Number(major),
    minor: Number(minor),
    revision: revision ?? '',
    build: Number(build ?? 0),
  };
}
